module.exports = __webpack_public_path__ + "img/CellHost-1.e62c3779.png";